export default {"src":"/_next/static/media/illustration-preservatives.0f008d7d.svg","height":55,"width":51};